import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { EmojiButton } from 'uikit/reactions';

import QuillUploadButton from './quillUploadButton';
import QuillSubmitButton from './quillSubmitButton';

import styles from '../styles/quill.module.scss';

const QuillEditorActions = ({
  className = '',
  emojiPickerPosition,
  fileUploadAriaLabel = '',
  onEmojiSelected,
  onSubmitClicked,
  onUploadClicked,
  shouldAllowEmojis,
  shouldAllowUploads,
  shouldShowEmojiButton,
  shouldShowSubmitButton,
}) => (
  <div className={classnames(styles.actions, className)}>
    {(shouldAllowUploads) && (
      <QuillUploadButton fileUploadAriaLabel={fileUploadAriaLabel} onClick={onUploadClicked} />
    )}
    {(shouldAllowEmojis && shouldShowEmojiButton) && (
      <EmojiButton onSelect={onEmojiSelected} emojiPickerPosition={emojiPickerPosition} />
    )}
    {(shouldShowSubmitButton) && (
      <QuillSubmitButton onClick={onSubmitClicked} />
    )}
  </div>
);

QuillEditorActions.propTypes = {
  className: PropTypes.string,
  shouldShowEmojiButton: PropTypes.bool.isRequired,
  emojiPickerPosition: PropTypes.string.isRequired,
  shouldAllowUploads: PropTypes.bool.isRequired,
  shouldAllowEmojis: PropTypes.bool.isRequired,
  shouldShowSubmitButton: PropTypes.bool.isRequired,
  onUploadClicked: PropTypes.func.isRequired,
  onEmojiSelected: PropTypes.func.isRequired,
  onSubmitClicked: PropTypes.func.isRequired,
  fileUploadAriaLabel: PropTypes.string,
};

export default QuillEditorActions;
